import { css } from "@emotion/core";
import { fontTypes, color } from "../../constants/commons";

export const collapsableItemStyle = css`
  .collapsable-card-container {
    background: ${color.white};
    border-radius: 0.375em;
    box-shadow: 0em 0.25em 0.625em 0em ${color.shadow};
    padding: 1em;
  }
  .header-style {
    font-family: ${fontTypes.bold};
    height: 2em;
  }
  .scrollable-container {
    height: 20em;
    overflow: scroll;
  }
`;
